import axios from 'axios';

import { backendRequestHeaders, getBackendBaseUrl } from '@/api/backendAuth';
import { getSessionBearerToken } from '@/utils/auth/sessionTokenBridge';

export const PENDING_TENANT_ID_STORAGE_KEY = 'churnsignal_pending_tenant_id';
export const PENDING_COMPANY_NAME_STORAGE_KEY = 'churnsignal_pending_company_name';

/** localStorage so Path B survives opening /sign-up in another tab; cleared after link. */
export function readPendingTenantId(): string | null {
  return (
    localStorage.getItem(PENDING_TENANT_ID_STORAGE_KEY)?.trim() ||
    sessionStorage.getItem(PENDING_TENANT_ID_STORAGE_KEY)?.trim() ||
    null
  );
}

export function writePendingTenantId(tenantId: string): void {
  localStorage.setItem(PENDING_TENANT_ID_STORAGE_KEY, tenantId);
  sessionStorage.setItem(PENDING_TENANT_ID_STORAGE_KEY, tenantId);
}

export function clearPendingTenantId(): void {
  localStorage.removeItem(PENDING_TENANT_ID_STORAGE_KEY);
  sessionStorage.removeItem(PENDING_TENANT_ID_STORAGE_KEY);
}

/** Company name from /register-company — used to prefill org confirm (Path B custom mode). */
export function readPendingCompanyName(): string | null {
  return (
    localStorage.getItem(PENDING_COMPANY_NAME_STORAGE_KEY)?.trim() ||
    sessionStorage.getItem(PENDING_COMPANY_NAME_STORAGE_KEY)?.trim() ||
    null
  );
}

export function writePendingCompanyName(companyName: string): void {
  const trimmed = companyName.trim();
  if (!trimmed) return;
  localStorage.setItem(PENDING_COMPANY_NAME_STORAGE_KEY, trimmed);
  sessionStorage.setItem(PENDING_COMPANY_NAME_STORAGE_KEY, trimmed);
}

export function clearPendingCompanyName(): void {
  localStorage.removeItem(PENDING_COMPANY_NAME_STORAGE_KEY);
  sessionStorage.removeItem(PENDING_COMPANY_NAME_STORAGE_KEY);
}

/** Clears both Path B pending keys (after successful tenant↔org link). */
export function clearPendingRegistration(): void {
  clearPendingTenantId();
  clearPendingCompanyName();
}

export async function linkClerkOrg(tenantId: string, clerkOrgId: string): Promise<void> {
  const base = getBackendBaseUrl();
  const bearer = await getSessionBearerToken();
  await axios.post(
    `${base}/tenants/link-clerk-org`,
    { tenantId, clerkOrgId },
    { headers: backendRequestHeaders(bearer) },
  );
}
